module.exports = __webpack_public_path__ + "static/media/DevRadar.9631a12b.png";